import script from "./TableLike.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableLike.vue?vue&type=script&lang=ts&setup=true"

import "./TableLike.vue?vue&type=style&index=0&id=ff758d3c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff758d3c"]])

export default __exports__